import prettyBytes from "pretty-bytes";
import { twMerge } from "tailwind-merge";

import type { FileItem } from "@/features/my-files/types";

import { DesignThumbnail } from "./DesignThumbnail";
import { FileIcon } from "./FileIcon";
import { selectionOrder } from "./selectionOrder";
import { SelectionOrderBadge } from "./SelectionOrderBadge";

export function DesignsListView({
  files,
  onOpen,
  selectedFileIds,
}: {
  files: FileItem[];
  onOpen: (fileItem: FileItem) => void;
  selectedFileIds: FileItem["id"][];
}) {
  return (
    <table className="w-full table-fixed border-collapse">
      <thead className="sticky top-0 z-10 bg-bg-primary">
        <tr className="border-b border-border-secondary text-left text-xs font-medium text-text-tertiary">
          <th className="px-xl py-md">Name</th>
          <th className="w-[100px] px-xl py-md">Version</th>
          <th className="w-[146px] px-xl py-md">Last modified</th>
          <th className="w-[100px] px-xl py-md">File Type</th>
          <th className="w-[96px] px-xl py-md">File Size</th>
        </tr>
      </thead>
      <tbody>
        {files.map((fileItem) => {
          const order =
            fileItem.type === "file"
              ? selectionOrder(selectedFileIds, fileItem.id)
              : undefined;

          return (
            <tr
              className={twMerge(
                "cursor-pointer border-b border-border-secondary text-sm text-text-secondary hover:bg-bg-primary-hover",
                order !== undefined && "bg-bg-brand-primary",
              )}
              key={`${fileItem.type}-${fileItem.id}`}
              onClick={() => onOpen(fileItem)}
            >
              <td className="px-xl py-lg">
                <span className="flex items-center gap-lg">
                  {order !== undefined && selectedFileIds.length > 1 && (
                    <SelectionOrderBadge order={order} />
                  )}
                  {fileItem.type === "file" ? (
                    <DesignThumbnail
                      className="size-3xl shrink-0 rounded-xs object-cover"
                      design={fileItem}
                    />
                  ) : (
                    <FileIcon fileItem={fileItem} />
                  )}
                  <span className="truncate text-text-primary">
                    {fileItem.name}
                  </span>
                </span>
              </td>
              <td className="px-xl py-lg">
                {"version" in fileItem ? fileItem.version : "-"}
              </td>
              <td className="px-xl py-lg">{fileItem.createdAt}</td>
              <td className="px-xl py-lg">
                {fileItem.type === "file"
                  ? fileItem.extension.toUpperCase()
                  : "Folder"}
              </td>
              <td className="px-xl py-lg">
                {fileItem.size === 0 ? "-" : prettyBytes(fileItem.size)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
